import { isMelangeHome, isRowingBlazers } from '../retailer';

export default function showRrLogoStamp() {
  return !(isRowingBlazers() || isMelangeHome());
}
